import {Component, OnInit, ViewChild} from '@angular/core';
import {IOption} from "ng-select";
import {BsModalRef, BsModalService} from "ngx-bootstrap";
import {NgxSpinnerService} from "ngx-spinner";
import {ApprovalMasterService} from "../../services/approval-master.service";
import {HelperService} from "../../services/helper.service";
import {RilrService} from "../../services/rilr.service";
import {TosterMessageService} from "../../services/toster-message.service";

@Component({
  selector: 'app-approval-pertmit-to-work-print',
  templateUrl: './approval-pertmit-to-work-print.component.html',
  styleUrls: ['./approval-pertmit-to-work-print.component.scss'],
  providers: [RilrService, ApprovalMasterService, TosterMessageService],
})
export class ApprovalPertmitToWorkPrintComponent implements OnInit {

  public masterData: any = {};
  public accidentScatArr: any = [];
  public incidentColspan: number = 0;
  public reportSystemID: number;
  public documentSystemID: number;
  public successMsg: string = "";
  public documentData: any = {};
  public reportCheckListCategory: any = {};
  public checklistColumnsArr: any[];
  public reportCheckList: any = [];
  public documentTypeLabel: string = "incident report";

  public incidentTypeArr: Array<IOption> = [];

  public companySystemID = this.helperService.getSelectedCompanyId();

  incidentCategoryArr: any[];
  incidentSubCategoryArr: any[];
  incidentSubCategoryDynamicArr: any[];
  correctiveactionstbl: any = [];
  approveRec: any = {};
  public approveData: any = {};

  @ViewChild('swalModalNotAccess') swalModalNotAccess: any;
  @ViewChild('swalModalDelete') swalModalDelete: any;
  @ViewChild('errorMessageHtml') errorMessageHtml: any;
  @ViewChild('swalModal') private swalModal: any;
  @ViewChild('swalModalRejectCheck') private swalModalRejectCheck: any;

  @ViewChild('swalModalApprovalCheck') private approvalCheckSwal: any;
  @ViewChild('swalModalPageRedirection') private swalModalPageRedirection: any;

  constructor(public bsModalRef: BsModalRef,
              private helperService: HelperService,
              private spinner: NgxSpinnerService,
              private modalService: BsModalService,
              private tosterMessageService: TosterMessageService,
              private approvalMasterService: ApprovalMasterService,
              private rilrService: RilrService) {
  }

  ngOnInit() {
    this.spinner.show();
    setTimeout(() => {
      this.reportPrintPreview();
    }, 0);

  }

  reportPrintPreview() {
    const that = this;
    that.rilrService
      .reportPrintPreviewData()
      .get({
        companySystemID: that.companySystemID,
        reportSystemID: that.reportSystemID,
        documentSystemID: that.documentSystemID
      })
      .subscribe(data => {
        const resp = data.data.data;
        that.incidentTypeArr = that.helperService.incidentsIdChangeToInt(resp.incidents);
        that.incidentCategoryArr = resp.incidentCategory;
        that.incidentSubCategoryArr = resp.IncidentSubCategory;
        that.incidentColspan = that.incidentTypeArr.length;
        that.masterData = resp.reportData;
        that.documentData = resp.document;
        that.incidentSubCategoryDynamicArr = resp.incidentDynamicSubCategory;
        that.correctiveactionstbl = resp.actions;
        that.documentTypeLabel = resp.document.documentDescription;
        that.accidentScatArr = resp.accidentScat;
        that.checklistColumnsArr = resp.headerColumns;
        that.reportCheckListCategory = resp.reportCheckListCategory;
        that.reportCheckList = resp.reportCheckList;
        that.spinner.hide();
      }, (error) => {
        that.spinner.hide();
      });
  }

  print_pdf_preview() {
    this.rilrService
      .printPermitToWorkPDF()
      .get({
        id: this.reportSystemID,
        documentSystemID: this.documentSystemID,
        companySystemID: this.companySystemID,
      })
      .subscribe(resp => {
        const data = resp.data.data;
        window.open(data.pdf_path, "_blank");
      }, (error) => {
        if (error.status == 500) {
        }
      });
  }

  public approve() {
    this.approvalCheckSwal.show();
  }

  public approveDocument() {
    const that = this;
    that.spinner.show();
    that.approvalMasterService
      .approveDocument()
      .post(that.approveRec)
      .subscribe(resp => {
        that.spinner.hide();
        that.successMsg = "Successfully approved the document";
        that.showSuccess();
      }, (error) => {
        that.spinner.hide();
        that.tosterMessageService.showError('Error', error.data.message);
      });
  }

  cancelApproveDocument() {
    this.approveRec = {};
  }

  reject() {
    this.swalModalRejectCheck.show();
  }

  showSuccess() {
    setTimeout(() => {
      this.swalModal.show();
    }, 0);
  }

  public rejectDocument(data) {
    const that = this;
    that.spinner.show();
    that.approveRec.rejectedComment = data;
    that.approvalMasterService
      .rejectDocument()
      .post(that.approveRec)
      .subscribe(resp => {
        that.spinner.hide();
        if (that.documentSystemID == 15) {
          that.swalModalPageRedirection.show();
        } else {
          that.successMsg = "Successfully rejected the document";
          that.showSuccess();
        }
      }, (error) => {
        that.spinner.hide();
        that.tosterMessageService.showError("Error", error.data.message);
      });
  }

  closeModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason('approval_ptw_closed');
  }

}



// WEBPACK FOOTER //
// /app/src/app/shared/approval-pertmit-to-work-print/approval-pertmit-to-work-print.component.ts